import { get, post, put, postFormData, del } from 'utils/methods';

export function getOrderApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}orders`, data, headers);
}

export function addOrderItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item`, data, headers);
}

export function editOrderItemApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/order-item`, data, headers);
}

export function deleteOrderItemApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/order-item`, data, headers);
}

export function attachAddressToOrderItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/address`, data, headers);
}

export function detachAddressFromOrderItemApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/address`, data, headers);
}

export function reprintOrderItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/reprint`, data, headers);
}

export function changeStatusOrderApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/status`, data, headers);
}

export function cloneOrderApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/clone`, data, headers);
}

export function getSellPricesApi(data) {
    return get(`${process.env.REACT_APP_REST}sell-prices/${data.configuration}/${data.product_group}/${data.reseller}${data.category ? `/${data.category}` : ''}`);
}

export function commentOrderItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/comment`, data, headers);
}

export function linkOrderItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/document`, data, headers);
}

export function addDocumentOrderItemApi(data, headers) {
    return postFormData(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/document`, data, headers);
}

export function deleteDocumentOrderItemApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/document`, data, headers);
}

export function deleteLinkOrderItemApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/document`, data, headers);
}

export function addNewOrderApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order`, data, headers);
}

export function editOrderApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/order`, data, headers);
}

export function addAdditionalItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/additional-cost`, data, headers);
}

export function deleteAdditionalItemApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/order/additional-cost`, data, headers);
}

export function attachBillingAccountToOrderApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/billing-account`, data, headers);
}

export function addFavorisOrderApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_USERS}commands/favorite-order`, data, headers);
}

export function deleteFavorisOrderApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_USERS}commands/favorite-order`, data, headers);
}

export function getBillingAccountApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}addresses`, data, headers);
}

export function addPaymentOrderApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/payment`, data, headers);
}

export function addPaymentRequestOrderApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/payment-request`, data, headers);
}

export function deletePaymentOrderApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/order/payment`, data, headers);
}

export function getPaymentTypesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}payment-types`, data, headers);
}

export function deletePrintingFileApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/printing-file`, data, headers);
}

export function editShippingTypesApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/shipping-type`, data, headers);
}

export function addPrintingFileApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/printing-file`, data, headers);
}

export function addDiscountIntoOrderApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/discount`, data, headers);
}

export function downloadOrderPdfApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order/pdf`, data, headers);
}

export function downloadOrderItemPdfApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/generate-pdf`, data, headers);
}

export function generateStatisticsApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}statistics`, data, headers);
}
